export default "__VITE_ASSET__CufUKlri__"